import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSystemPreferences } from "../../data/queries/systemPreferencesQueries";
import { useUpdateSystemPreferences } from "../../data/mutations/systemPreferencesMutations";
import { toast } from "react-toastify";
import { NotificationsContent } from "./SystemPreferencesComponents/NotificationsContent";

export const SystemPreferencesContent = () => {
  const { t } = useTranslation(["Preferences"]);

  const taskApproachingEmailEnabledRef = useRef(null);
  const taskApproachingDaysPriorRef = useRef(null);

  const { data: systemPreferences, isPending } = useSystemPreferences();
  const { mutate: updateSystemPreferences } = useUpdateSystemPreferences();

  const handleSystemPreferencesChange = () => {
    const systemPreferences = {
      TaskApproachingEmailEnabled:
        taskApproachingEmailEnabledRef.current?.checked,
      TaskApproachingDaysPrior: taskApproachingDaysPriorRef.current?.getValue(),
    };

    updateSystemPreferences(
      {
        systemPreferences: systemPreferences,
      },
      {
        onSuccess: () => {
          toast.success(t("SystemPreferences.Updated"), {
            position: "bottom-left",
          });
        },
        onError: () => {
          toast.error(t("SystemPreferences.Error"), {
            position: "bottom-left",
          });
        },
      }
    );
  };

  if (isPending) return null;

  return (
    <NotificationsContent
      taskApproachingEmailEnabledRef={taskApproachingEmailEnabledRef}
      taskApproachingDaysPriorRef={taskApproachingDaysPriorRef}
      systemPreferences={systemPreferences}
      onChange={handleSystemPreferencesChange}
    />
  );
};
